var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayoutCta3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 36,
  viewBox: "0 0 48 36",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M44 0a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm0 4H4v28h40zM28.706 18.17l5.84 6.341-3.11-.014.824 3.074-1.932.517-.823-3.073-2.686 1.567zM38 12a2 2 0 1 1 0 4h-4a2 2 0 1 1 0-4zm-12 0a2 2 0 1 1 0 4h-4a2 2 0 1 1 0-4zm-12 0a2 2 0 1 1 0 4h-4a2 2 0 1 1 0-4z"
})));
export default SvgLayoutCta3;